// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"_3fbaf7d","status":"_81ed4a4"};